
import { useState } from "react"
import { Link } from "react-router-dom"

export default function Team2({ alt }) {

	const [isAccordion, setIsAccordion] = useState(1)

	const handleAccordion = (key) => {
		setIsAccordion(prevState => prevState === key ? null : key)
	}

	return (

		<section className={`team-section section-padding  ${alt ? '' : 'pt-0'}`} id="team">
			<div className="shape-1 float-bob-y">
				{/* <img src="assets/img/team/shape-1.png" alt="img" /> */}
			</div>
			<div className="shape-2">
				{/* <img src="assets/img/team/shape-2.png" alt="img" /> */}
			</div>
			<div className="container">
				<div className="section-title text-center">
					<h6 className="wow fadeInUp"><i className="fa-regular fa-arrow-left-long" />our team members<i className="fa-regular fa-arrow-right-long" /></h6>
					<h2 className="wow fadeInUp" data-wow-delay=".2s">Leadership Behind V-Make</h2>
				</div>
				<div className="row justify-content-center">
					<div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 wow fadeInUp" onMouseEnter={() => handleAccordion(1)}>
						<div className={`team-box-items ${isAccordion === 1 ? 'active' : ''}`}>
							<div className="social-icon d-grid align-items-center">
								{/* <Link to="/#"><i className="fab fa-linkedin-in" /></Link>
								<Link to="/#"><i className="fab fa-twitter" /></Link> */}
								<Link to="https://www.instagram.com/vishal_kalariya_/"><i className="fab fa-instagram" /></Link>
								<Link to="https://wa.me/917829611980"><i className="fab fa-whatsapp" /></Link>
							</div>
							<div className="team-image">
								<img src="assets/img/team/Vishal.png" alt="img" />
							</div>
							<div className="team-content">
								<h5><Link to="/team-details">Vishal Patel</Link></h5>
								<p>CEO</p>
								{/* <Link to="/team-details" className="icon"><i className="fa-solid fa-link" /></Link> */}
							</div>
						</div>
					</div>
					<div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 wow fadeInUp" onMouseEnter={() => handleAccordion(2)} data-wow-delay=".2s">
						<div className={`team-box-items ${isAccordion === 2 ? 'active' : ''}`}>
							<div className="social-icon d-grid align-items-center">
								{/* <Link to="/#"><i className="fab fa-linkedin-in" /></Link>
								<Link to="/#"><i className="fab fa-twitter" /></Link> */}
								<Link to="https://www.instagram.com/__harsh__patel__official/"><i className="fab fa-instagram" /></Link>
								<Link to="https://wa.me/919620340995"><i className="fab fa-whatsapp" /></Link>
							</div>
							<div className="team-image">
								<img src="assets/img/team/Harsh.png" alt="img" width="265" height="208" />
							</div>
							<div className="team-content">
								<h5><Link to="/team-details">Harsh Patel</Link></h5>
								<p>CFO</p>
								{/* <Link to="/team-details" className="icon"><i className="fa-solid fa-link" /></Link> */}
							</div>
						</div>
					</div>
					<div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 wow fadeInUp" onMouseEnter={() => handleAccordion(2)} data-wow-delay=".2s">
						<div className={`team-box-items ${isAccordion === 3 ? 'active' : ''}`}>
							<div className="social-icon d-grid align-items-center">
								{/* <Link to="/#"><i className="fab fa-linkedin-in" /></Link>
								<Link to="/#"><i className="fab fa-twitter" /></Link> */}
								<Link to="#"><i className="fab fa-instagram" /></Link>
								<Link to="#"><i className="fab fa-whatsapp" /></Link>
							</div>
							<div className="team-image">
								<img src="assets/img/team/Vasath.png" alt="img"  />
							</div>
							<div className="team-content">
								<h5><Link to="/team-details">Vasant Patel</Link></h5>
								<p>Director</p>
								{/* <Link to="/team-details" className="icon"><i className="fa-solid fa-link" /></Link> */}
							</div>
						</div>
					</div>
					{/* <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 wow fadeInUp" onMouseEnter={() => handleAccordion(3)} data-wow-delay=".4s">
						<div className={`team-box-items ${isAccordion === 3 ? 'active' : ''}`}>
							<div className="social-icon d-grid align-items-center">
								<Link to="/#"><i className="fab fa-linkedin-in" /></Link>
								<Link to="/#"><i className="fab fa-twitter" /></Link>
								<Link to="/#"><i className="fab fa-instagram" /></Link>
								<Link to="/#"><i className="fab fa-facebook-f" /></Link>
							</div>
							<div className="team-image">
								<img src="assets/img/team/07.jpg" alt="img" />
							</div>
							<div className="team-content">
								<h5><Link to="/team-details">CEO</Link></h5>
								<p>CEO</p>
								<Link to="/team-details" className="icon"><i className="fa-solid fa-link" /></Link>
							</div>
						</div>
					</div> */}
					{/* <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 wow fadeInUp" onMouseEnter={() => handleAccordion(4)} data-wow-delay=".6s">
						<div className={`team-box-items ${isAccordion === 4 ? 'active' : ''}`}>
							<div className="social-icon d-grid align-items-center">
								<Link to="/#"><i className="fab fa-linkedin-in" /></Link>
								<Link to="/#"><i className="fab fa-twitter" /></Link>
								<Link to="/#"><i className="fab fa-instagram" /></Link>
								<Link to="/#"><i className="fab fa-facebook-f" /></Link>
							</div>
							<div className="team-image">
								<img src="assets/img/team/08.jpg" alt="img" />
							</div>
							<div className="team-content">
								<h5><Link to="/team-details">CEO</Link></h5>
								<p>CEO</p>
								<Link to="/team-details" className="icon"><i className="fa-solid fa-link" /></Link>
							</div>
						</div>
					</div> */}
				</div>
			</div>
		</section>

	)
}
